<template>
    <div v-if="genre">
        <PageHeader type="Genre" :title="genre.name">
            <template #meta v-if="genre.description"><span v-html="genre.description"></span></template>
        </PageHeader>
        <TrackList :songs="genre.songs || []" :ad-after="[4, 24]" header />
    </div>
</template>

<script>
import PageHeader from "@/components/ui/PageHeader.vue";
import TrackList from "@/components/ui/TrackList.vue";
import { defineAsyncComponent } from 'vue'
import { Link, usePage } from "@inertiajs/vue3";
import { mapState, mapActions, mapGetters } from "vuex";
import CardSong from '@/components/CardSong.vue'
export default {
    created() {
        const id = usePage().props.query.id;
        this.getSignleGenre(id);
    },
    methods: {
        ...mapActions("genre", ["getSignleGenre"]),
    },
    computed: {
        ...mapState({ genre: (state) => state.genre.single }),
    },
    components: {
        PageHeader, TrackList,
        CardSong,
    },
    mounted() {
        document.title = genre.name + " Genre"
    },
}
</script>